import * as React from "react";
import { Segment, Grid, Header, Button, List, GridColumn, GridRow, ListItem, ListHeader } from "@/components/bp/bp-ui";
import { TranslationContext } from "../../../Contexts/TranslationContext";
import { ClientResources, FamilialSearchCaseRunCreateModel, RunParameterModel } from "@app/api2/api";
import { ParametersView } from "../../ParametersView";
import { IParameterRenderer } from "../../ParameterRendererAbstracts";
import { BPButton } from "@/components/bp/bpbutton";

interface IReviewFamilialSearchProps {
    model: FamilialSearchCaseRunCreateModel;
    onComplete: (values: any) => void;
    router: any;
    parameterRenderer: IParameterRenderer;
}

class ReviewFamilialSearchState {

}

export class ReviewFamilialSearch extends React.Component<IReviewFamilialSearchProps, ReviewFamilialSearchState> {
    
    constructor(props, context) {
        super(props, context);

        this.state = {

        };

    }

    isRowVisible = (p: RunParameterModel) => {
        if (!p.userVisible) {
            return false;
        }
        if (!p.showIfChecked) {
            return true;
        }

        var fields = p.showIfChecked.split(',');

        var falseFields = fields.filter(f => f.startsWith("!")).map(m => m.slice(1));
        var trueFields = fields.filter(f => !f.startsWith("!"));

        var values = this.props.model.parameters.reduce((dict, curr) => {
            dict[curr.parameter] = curr.value;
            return dict;
        }, {});

        return falseFields.reduce((show, field) => show && !(values[field] === "1"), true) && trueFields.reduce((show, field) => show && (values[field] === "1"), true);
    };

    render() {
        const population = this.props.model.populations.find((p) => (p.id === this.props.model.populationId));
        return (<TranslationContext.Consumer>{t =>
            <div>
                <Grid columns={4}>
                    <GridRow>
                        <GridColumn>
                            <Header attached="top">{t.caseRun.general}</Header>
                            <Segment attached>
                                <List>
                                    <ListItem>
                                        <ListHeader>{t.common.population}</ListHeader>
                                        {population != null ? population.name : ""}
                                    </ListItem>
                                </List>
                            </Segment>
                        </GridColumn>
                        <GridColumn>
                            <Header attached="top">{t.common.contributors}</Header>
                            <Segment attached>
                                <List>
                                    {this.props.model.references.filter((p) => (p.selected)).map((p) => (
                                        <ListItem key={p.id}>{p.name}</ListItem>
                                    ))}
                                </List>
                            </Segment>
                        </GridColumn>
                    </GridRow>
                </Grid>
                <Header attached="top">{t.common.parameters}</Header>
                <Segment attached>
                    <ParametersView parameters={this.props.model.parameters} parameterRenderer={this.props.parameterRenderer} model={{...this.props.model, efmCaseId: this.props.model.efmCaseId, hp: this.props.model.references }} />
                </Segment>
                <Segment basic clearing>
                    <BPButton floated="right" type="submit" onClick={this.props.onComplete} positive primary>{t.caseRun.queueRun}</BPButton>
                </Segment>
            </div>}</TranslationContext.Consumer>);
    }
}



